var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInstruct = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_6515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 2.33334C7.55696 2.33334 2.33325 7.55705 2.33325 13.9995C2.33325 20.442 7.55696 25.6667 13.9994 25.6667C20.4419 25.6667 25.6666 20.442 25.6666 13.9995C25.6666 7.55705 20.4419 2.33334 13.9994 2.33334ZM16.4281 20.4143C15.8276 20.6514 15.3495 20.8311 14.991 20.9556C14.6335 21.08 14.2177 21.1422 13.7446 21.1422C13.0177 21.1422 12.4518 20.9645 12.0488 20.6099C11.6458 20.2553 11.4454 19.8059 11.4454 19.2598C11.4454 19.0474 11.4602 18.8301 11.4898 18.6089C11.5204 18.3877 11.5688 18.1388 11.635 17.8593L12.3866 15.2045C12.4528 14.9496 12.51 14.7077 12.5555 14.4825C12.6009 14.2553 12.6226 14.0469 12.6226 13.8573C12.6226 13.5195 12.5525 13.2825 12.4133 13.1491C12.272 13.0158 12.0063 12.9506 11.6103 12.9506C11.4167 12.9506 11.2172 12.9793 11.0128 13.0395C10.8103 13.1017 10.6345 13.158 10.4903 13.2133L10.6888 12.3956C11.1807 12.1951 11.6518 12.0232 12.1012 11.881C12.5505 11.7368 12.9752 11.6657 13.3752 11.6657C14.0972 11.6657 14.6542 11.8415 15.0463 12.1891C15.4365 12.5378 15.633 12.9911 15.633 13.5482C15.633 13.6637 15.6192 13.8672 15.5925 14.1575C15.5658 14.4489 15.5155 14.7146 15.4424 14.9585L14.6947 17.6054C14.6335 17.8178 14.5792 18.0608 14.5298 18.3324C14.4814 18.604 14.4577 18.8114 14.4577 18.9506C14.4577 19.3022 14.5357 19.5422 14.6937 19.6696C14.8498 19.797 15.1234 19.8612 15.5105 19.8612C15.6933 19.8612 15.8977 19.8287 16.1288 19.7654C16.3579 19.7022 16.5239 19.6459 16.6286 19.5975L16.4281 20.4143ZM16.2957 9.67063C15.9471 9.99458 15.5273 10.1566 15.0365 10.1566C14.5466 10.1566 14.1239 9.99458 13.7723 9.67063C13.4226 9.34668 13.2458 8.9526 13.2458 8.49236C13.2458 8.0331 13.4236 7.63804 13.7723 7.31112C14.1239 6.98322 14.5466 6.82026 15.0365 6.82026C15.5273 6.82026 15.9481 6.98322 16.2957 7.31112C16.6444 7.63804 16.8192 8.0331 16.8192 8.49236C16.8192 8.95359 16.6444 9.34668 16.2957 9.67063Z",
    fill: "url(#paint0_linear_640_6515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_6515",
    x1: 2.33325,
    y1: 12.25,
    x2: 25.6666,
    y2: 12.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_6515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3333,
    height: 23.3333,
    fill: "white",
    transform: "translate(2.33325 2.33334)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstruct, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instruct.1b1ef03b.svg";
export { ForwardRef as ReactComponent };